//my edits
import Axios from "axios";
import { API_HOST } from "~src/data/constant";

Axios.defaults.withCredentials = true;
Axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
Axios.defaults.xsrfCookieName = "csrftoken";

class ApiClient {
    constructor() {
        this.csrfToken = null;
        this.csrfPromise = null;
    }

    async getCsrfToken() {
        // Return existing token if available
        if (this.csrfToken) {
            return this.csrfToken;
        }

        // If there's already a request in progress, return its promise
        if (this.csrfPromise) {
            return this.csrfPromise;
        }

        // Create new request
        this.csrfPromise = Axios.get(`${API_HOST}/csrf/`)
            .then(response => {
                this.csrfToken = response.csrfToken;
                this.csrfPromise = null;
                return this.csrfToken;
            })
            .catch(error => {
                this.csrfPromise = null;
                throw error;
            });

        return this.csrfPromise;
    }

    async callAPI(method, route, options = null, apiHost = null) {
        let isFileDownload = false; 
        const base = apiHost || API_HOST;
        try {
            // Check if this is a file download request
            isFileDownload = route.startsWith('download/') && options?.responseType === 'blob';
    
            if (isFileDownload) {
                // Special handling for file downloads
                const config = {
                    method,
                    url: `${base}/${route.replace(/^\/+/, '')}`,
                    responseType: 'blob',
                    headers: {
                        'Accept': 'application/pdf',
                        ...(options?.headers || {})
                    },
                    ...options
                };
    
                const response = await Axios(config);
                return {
                    msg: "success",
                    data: response.data,
                    headers: response.headers
                };
            }
    
            // if is is POST request then we can proceed with standard api call
            let response;
            if (method === "POST") {
                Axios.defaults.headers.common["X-CSRFTOKEN"] = await this.getCsrfToken();
                response = await Axios.post(`${base}/${route.replace(/^\/+/, '')}`, options);
            } else if (method === "GET") {
                response = await Axios.get(`${base}/${route.replace(/^\/+/, '')}`, {
                    signal: options?.signal
                });
            }
    
            return response.data;
    
        } catch (error) {
            // Special handling for blob errors in file downloads
            if (isFileDownload && error.response?.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    return { msg: "fail", message: `Download failed: ${text}` };
                } catch (blobError) {
                    return { msg: "fail", message: 'Failed to process response' };
                }
            }
    
            if (error.response?.status === 403 && error.response?.data?.code === "invalid_csrf_token") {
                this.csrfToken = null;
            }
            return { msg: "fail", message: error.message };
        }
    }
    
}

// Create a singleton instance
const apiClient = new ApiClient();
export default apiClient.callAPI.bind(apiClient);